import React, { ComponentType } from 'react';
import { MediaManagerApi, useMediaManagerApi } from '../hooks/useMediaManagerApi';
import type { UseMediaManagerApiParams } from '../hooks/useMediaManagerApi';

export function withMediaManagerApi<TProps extends UseMediaManagerApiParams>(
  Component: ComponentType<TProps & { mediaManagerApi: MediaManagerApi }>,
): ComponentType<TProps> {
  return (props) => {
    const api = useMediaManagerApi(props);

    return <Component {...props} mediaManagerApi={api} />;
  };
}
